/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import { gql, useQuery } from '@apollo/client';
import CONFIG from '../../config';


interface Terms {
  termsAndConditions?: { html: string };
}

interface QueryResult {
  termsOfUseAndPrivacyPolicy: Terms;
}

const FeedQuery = gql`
  query ($id: ID!) {
    termsOfUseAndPrivacyPolicy (where: { id: $id } , stage: PUBLISHED) {
      termsAndConditions {
        html
        }
    }
  }
`;

export const TermsAndConditions = () => {
  const { data, error } = useQuery<QueryResult>(FeedQuery, {
    variables: {
      id: CONFIG.graphCMSLegalId
    },
  });

  if (error || !data?.termsOfUseAndPrivacyPolicy.termsAndConditions) {
    return <></>
  }
  return (
    <div className='legal'>
      <div
        className='solution-text'
        dangerouslySetInnerHTML={{ __html: data.termsOfUseAndPrivacyPolicy.termsAndConditions.html }}
      />
    </div>
  )
}

